import { createContext } from 'react'

export const LevelContext = createContext({
    currentLevel: 0,
    setCurrentLevel: (value: number) => { }
})